import * as React from "react"
import { Box } from "@mui/material"
import {formatDate} from "@ui-seeker/utils";


export default function dateColumn() {
	return {
		name: 'date', label: 'Date',
		options: {
			headerAlign: 'center',
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{formatDate(value, { isString: true })}
			</Box>
		}
	}
}